import React from "react";

function Footer() {
    return(
        <div className="bg-indigo-300 h-50px w-full flex md:flex-row flex-col justify-center items-center p-5">
            <div className="colFT text-black text-center">
            <div className="text-sm md:text-lg lg: text-lg xl:text-xl font-bold">
                Contact Us
            </div>
            <a
                href="mailto:iwpfi2026@goddardcom.com"
                className="text-sm md:text-lg lg:text-lg xl:text-xl text-black hover:underline"
                >
                iwpfi2026@goddardcom.com
            </a>

            </div>
        </div>
    );
}

export default Footer